/* eslint-disable no-debugger, no-console */

// пакеты
// import '@/plugins/auth';

import auth from '@/plugins/auth-service';

auth.init();

import './registerServiceWorker.js';

// vue пакеты
import Vue from 'vue';
import { i18n } from './plugins/i18n';
import './plugins/signalr';
import store from './store';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
//import VueApexCharts from 'vue-apexcharts'
//import VueTrix from 'vue-trix'
import router from './router';

import { apolloProvider } from '@/plugins/apollo';
import '@/plugins/ag-grid';
import layout from '@/layouts';
import BeeBasePage from '@/components/bee-base/layout/bee-base-page';
import settings from '@/views/Settings.vue';
import market from '@/views/Market.vue';
//import VueQrcodeReader from 'vue-qrcode-reader'
import { ModelSelect } from 'vue-search-select';
import VueUploadComponent from 'vue-upload-component';
import { Multiselect } from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
//import VueColor from 'vue-color'
import vSelect from 'vue-select';
import SvgIcon from '@/components/bee-base/SvgIcon';
import Loader from '@/components/bee-base/loaders/Loader';

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueClipboard from 'vue-clipboard2';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

import useLocale from '@/composables/useLocale';
import { initializeUiTheme } from '@/composables/useUiTheme';
initializeUiTheme();
const { restoreLocale } = useLocale();

import { registerModules } from './register-modules';

// import overviewModule from './modules/overview';
import workCentersModule from './modules/workCenters';
import usersModule from './modules/users';
import lossesModule from './modules/losses';
import workCenterSettingsModule from './modules/workCenterSettings';
import profileModule from './modules/profile';
import analyticsModule from './modules/analytics';
import jobOrdersModule from './modules/jobOrders';
import workCenterCapacityModule from './modules/workCenterCapacity';
import outputModule from './modules/output';
import shiftsModule from './modules/shifts';
import companyModule from './modules/company';
import apiModule from './modules/api';
import lossReasonsModule from './modules/lossReasons';
import integrationsModule from './modules/integrations';
import notificationsModule from './modules/notifications';
import checklistsModule from './modules/checklists';
import templatesModule from './modules/templates';
import productsModule from './modules/products';
import materialsModule from './modules/materials';
import containersModule from './modules/containers';
import serialNumbersModule from './modules/serialNumbers';
import characteristicsModule from './modules/characteristics';
import measurementUnitsModule from './modules/measurementUnits';
import webhooksModule from './modules/webhooks';
import inspectionsModule from './modules/inspections';
import spcAnalysisModule from './modules/spcAnalysis';
import gridViewModule from './modules/gridView';
import VueIframe from 'vue-iframes';

Vue.use(VueIframe);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueFormWizard);

Vue.component('Layout', layout);
Vue.component('BeeBasePage', BeeBasePage);
Vue.component('Settings', settings);
Vue.component('Market', market);

Vue.component('SvgIcon', SvgIcon);
Vue.component('Loader', Loader);
//Vue.component('apexchart', VueApexCharts)
//Vue.component('vue-trix', VueTrix)
Vue.component('ModelSelect', ModelSelect);
Vue.component('Multiselect', Multiselect);
//Vue.component('vue-color', VueColor)
Vue.component('FileUpload', VueUploadComponent);
Vue.component('VueSlider', VueSlider);
Vue.component(VueCountdown.name, VueCountdown);
Vue.component('v-select', vSelect);

Vue.config.ignoredElements = [
  'a-scene',
  'a-camera',
  'a-assets',
  'a-image',
  'a-asset-item',
  'a-entity',
  'a-plane',
  'a-gltf-model',
  'a-sky',
  'a-text',
  'a-box',
];

// Плагины стандартные
Vue.use(BootstrapVue);
//Vue.use(VueQrcodeReader)

restoreLocale();

registerModules({
  // overview: overviewModule,
  workCenters: workCentersModule,
  users: usersModule,
  events: lossesModule,
  workCenterSettings: workCenterSettingsModule,
  profile: profileModule,
  analytics: analyticsModule,
  jobOrders: jobOrdersModule,
  workCenterCapacity: workCenterCapacityModule,
  output: outputModule,
  shifts: shiftsModule,
  company: companyModule,
  api: apiModule,
  lossReaons: lossReasonsModule,
  integrations: integrationsModule,
  notifications: notificationsModule,
  checklists: checklistsModule,
  templates: templatesModule,
  products: productsModule,
  materials: materialsModule,
  containers: containersModule,
  serialNumbers: serialNumbersModule,
  characteristics: characteristicsModule,
  measurementUnits: measurementUnitsModule,
  webhooks: webhooksModule,
  inspections: inspectionsModule,
  spcAnalysis: spcAnalysisModule,
  gridView: gridViewModule,
});

new Vue({
  i18n,
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app');
